<template>
  <v-row no-gutters class="pt-5">
    <v-col cols="12">
      <v-row no-gutters v-if="statistics">
        <v-col>
          <nmt-sidebar-profile-stats :statistics="statistics"> </nmt-sidebar-profile-stats>
        </v-col>
      </v-row>
      <v-row no-gutters @mouseenter="hovered = true" @mouseleave="hovered = false">
        <v-col style="position: relative">
          <template v-if="hovered">
            <span style="position: absolute; top: 35px; right: 50px">
              <table-button name="showDialog" is-context @click="$emit('showDialog')" icon="mdi-magnify" />
            </span>
            <span style="position: absolute; top: 35px; right: 15px">
              <table-button name="downloadChart" is-context @click="downloadChart" icon="mdi-download" />
            </span>
          </template>
          <nmt-sidebar-profile-chart ref="chart" v-bind="$props" v-on="$listeners"></nmt-sidebar-profile-chart>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import NmtSidebarProfileStats from '@/components/NmtSidebarProfileStats';
import NmtSidebarProfileChart from '@/components/NmtSidebarProfileChart';
import TableButton from '@/components/TableButton';

export default {
  name: 'NmtSidebarProfile',
  components: {
    NmtSidebarProfileChart,
    NmtSidebarProfileStats,
    TableButton,
  },
  props: {
    statistics: {
      type: Array,
    },
    heights: {
      type: Array,
      required: true,
    },
    interval: {
      type: Number,
      required: true,
    },
    length: {
      type: String,
      required: true,
    },
    fresnelZonePoints: {
      type: Array,
    },
    titlePath: {
      type: String,
      default: 'dialog.title.nmtProfile',
    },
  },
  data: () => ({
    hovered: false,
  }),
  methods: {
    downloadChart() {
      this.$refs.chart.downloadChart(this.$i18n.t(this.titlePath));
    },
  },
};
</script>

<style lang="scss" scoped></style>
